define((require) => {
    "use strict";

    var EasingTypes  = require("shared/ui/experience/widgets/animations/EasingTypes"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/widgets/animations/zoomIn/ZoomInAnimationPropertiesView.tpl");

    /**
     * The properties view for a zoom in animation.
     *
     * @class ZoomInAnimationPropertiesView
     * @constructor
     *
     * @cfg {ZoomInAnimationModel} model The zoom in animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#zoomInEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/zoomIn/ZoomInAnimationPropertiesView.js